import React from 'react';
import AppPage from './AppPage';
import { orderFormPdfUrl } from '../../api/signup';

function ChecklistIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="12" fill="#1ABC9C" />
      <path
        d="M7 12.5l3 3 7-7"
        stroke="#fff"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function DoneView({ token, state }) {
  // The portal invite goes to the POC — the merchant-facing address for
  // every customer email. The billing contact only receives invoices.
  const email = state?.email;
  const billingEmail = state?.identity?.billing_contact_email;
  // Invoice merchants: who bills, in what currency, to whom — when the API
  // sends it (older APIs don't; they keep the generic line).
  const invoiceLine =
    state?.billing_entity && state?.currency
      ? [
          `First invoice from ${state.billing_entity}`,
          `in ${state.currency}`,
          state?.frequency !== 'annual_prepaid' && 'Net 30',
          billingEmail && `sent to ${billingEmail}`,
        ]
          .filter(Boolean)
          .join(', ')
      : 'Monthly invoice with a payment link';

  return (
    <AppPage>
      <div className="confirm-check">
        <svg viewBox="0 0 24 24" fill="none">
          <path
            d="M5 13l4 4L19 7"
            stroke="#1ABC9C"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <h1 className="signup-title">You&apos;re all set!</h1>
      <p className="signup-sub">
        {state?.business || 'Your brand'} is signed up.
      </p>
      <div className="signup-checklist">
        <div className="checklist-item">
          <ChecklistIcon />
          Order form signed
        </div>
        {state?.payment_at_signup === 'invoice' ? (
          <div className="checklist-item">
            <ChecklistIcon />
            {invoiceLine}
          </div>
        ) : (
          <div className="checklist-item">
            <ChecklistIcon />
            Payment method on file
          </div>
        )}
      </div>
      <p className="text-sm text-up-clr-dark-grey leading-relaxed">
        We&apos;re creating your UrbanPiper portal now. Your invite will
        arrive
        {email ? (
          <>
            {' '}
            at <span className="font-semibold text-up-clr-black">{email}</span>
          </>
        ) : (
          ' by email'
        )}{' '}
        shortly — you can close this page.
      </p>
      <p className="text-sm mt-4">
        <a
          href={orderFormPdfUrl(token)}
          target="_blank"
          rel="noopener noreferrer"
          className="text-up-blue underline">
          View your signed Order Form ↗
        </a>
      </p>
    </AppPage>
  );
}

export default DoneView;
